import { css, SerializedStyles } from '@emotion/react';

const breakpoints = {
  mobile: 430,
  tablet: 768,
  laptop: 1280,
  desktop: 1920,
} as const;

type Breakpoint = keyof typeof breakpoints;

type MQ = {
  [K in Breakpoint]: (...args: Parameters<typeof css>) => SerializedStyles;
};

const mq = (Object.keys(breakpoints) as Breakpoint[]).reduce((acc, label) => {
  const px = breakpoints[label];
  acc[label] = (...args) => css`
    @media (min-width: ${px}px) {
      ${css(...args)}
    }
  `;
  return acc;
}, {} as MQ);

export const { mobile, tablet, laptop, desktop } = mq;
